import React from 'react'
import RastrearDeliveryFormPageContainer from './RastrearDeliveryFormPageContainer';

export class RastrearDeliveryFormPage extends React.Component{
    render(){
        return (
            <RastrearDeliveryFormPageContainer { ...this.props } />
        )
    }
}